import React from 'react';
import { useSelector } from 'react-redux';
import EntityDropdownField from 'components/EntityDropdownField';
import { selectFertilizerEntityTypeId } from 'services/schemas/selectors';

export interface Props {
    name: string;
    validate?: any;
    useCompositeKey?: boolean;
    disabled?: boolean;
}

export default function FertilizerSchemaEntityTypeEntityDropdownField(
    props: Props
): React.ReactElement | null {
    const { name, validate, useCompositeKey, disabled } = props;

    const fertilizerSchemaEntityTypeId = useSelector(
        selectFertilizerEntityTypeId
    );

    if (!fertilizerSchemaEntityTypeId) {
        return null;
    }

    return (
        <EntityDropdownField
            entityTypeId={fertilizerSchemaEntityTypeId}
            name={name}
            validate={validate}
            useCompositeKey={useCompositeKey}
            disabled={disabled}
        />
    );
}
